module.exports = __webpack_public_path__ + "img/ISOTIPO_OPENGES-01.be86c4fc.png";